export enum ESlackOAuthStatus {
  ACTIVE = 'active',
  SUSPEND = 'suspend'
}
